export const SEARCH_CARS_FETCH_DATA_LOADING = 'SEARCH_CARS_FETCH_DATA_LOADING';
export const SEARCH_CARS_FETCH_DATA_SUCCESS = 'SEARCH_CARS_FETCH_DATA_SUCCESS';
export const SEARCH_CARS_FETCH_DATA_ERROR = 'SEARCH_CARS_FETCH_DATA_ERROR';

export const SEARCH_MORE_CARS_FETCH_DATA_LOADING = 'SEARCH_MORE_CARS_FETCH_DATA_LOADING';
export const SEARCH_MORE_CARS_FETCH_DATA_SUCCESS = 'SEARCH_MORE_CARS_FETCH_DATA_SUCCESS';
export const SEARCH_MORE_CARS_FETCH_DATA_ERROR = 'SEARCH_MORE_CARS_FETCH_DATA_ERROR';
